var _path, _g, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCvRejected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7443_12881)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7443_12881",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0H0V18H18V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7443_12881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1603 0.983361C9.56019 0.250337 8.43917 0.250339 7.83902 0.983361L7.09516 1.89195L5.99665 1.47703C5.1104 1.14229 4.13961 1.70277 3.98638 2.63766L3.79646 3.79645L2.63766 3.98638C1.70277 4.13961 1.14228 5.11039 1.47703 5.99665L1.89195 7.09516L0.983358 7.83901C0.250337 8.43917 0.250339 9.56019 0.983365 10.1603L1.89195 10.9042L1.47703 12.0027C1.14228 12.8889 1.70276 13.8597 2.63766 14.0129L3.79646 14.2029L3.98638 15.3617C4.13961 16.2965 5.1104 16.8571 5.99665 16.5223L7.09516 16.1074L7.83902 17.016C8.43917 17.749 9.56019 17.749 10.1603 17.016L10.9042 16.1074L12.0027 16.5223C12.8889 16.8571 13.8597 16.2965 14.0129 15.3617L14.2029 14.2029L15.3617 14.0129C16.2965 13.8597 16.8571 12.8889 16.5223 12.0027L16.1074 10.9042L17.016 10.1603C17.749 9.56019 17.749 8.43917 17.016 7.83901L16.1074 7.09516L16.5223 5.99665C16.8571 5.1104 16.2965 4.13961 15.3617 3.98638L14.2029 3.79645L14.0129 2.63766C13.8597 1.70277 12.8889 1.14228 12.0027 1.47703L10.9042 1.89195L10.1603 0.983361Z",
    fill: "#E41D1D"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.70485 8.99957L11.8531 6.85634C11.9471 6.76227 12 6.63467 12 6.50163C12 6.36859 11.9471 6.241 11.8531 6.14692C11.759 6.05285 11.6314 6 11.4984 6C11.3653 6 11.2377 6.05285 11.1437 6.14692L9.00043 8.29515L6.85719 6.14692C6.76312 6.05285 6.63553 6 6.50249 6C6.36944 6 6.24185 6.05285 6.14778 6.14692C6.0537 6.241 6.00085 6.36859 6.00085 6.50163C6.00085 6.63467 6.0537 6.76227 6.14778 6.85634L8.29601 8.99957L6.14778 11.1428C6.10095 11.1893 6.06379 11.2445 6.03842 11.3054C6.01306 11.3663 6 11.4316 6 11.4975C6 11.5635 6.01306 11.6288 6.03842 11.6896C6.06379 11.7505 6.10095 11.8058 6.14778 11.8522C6.19422 11.899 6.24948 11.9362 6.31035 11.9616C6.37123 11.9869 6.43653 12 6.50249 12C6.56844 12 6.63374 11.9869 6.69462 11.9616C6.75549 11.9362 6.81075 11.899 6.85719 11.8522L9.00043 9.70399L11.1437 11.8522C11.1901 11.899 11.2454 11.9362 11.3062 11.9616C11.3671 11.9869 11.4324 12 11.4984 12C11.5643 12 11.6296 11.9869 11.6905 11.9616C11.7514 11.9362 11.8066 11.899 11.8531 11.8522C11.8999 11.8058 11.9371 11.7505 11.9624 11.6896C11.9878 11.6288 12.0009 11.5635 12.0009 11.4975C12.0009 11.4316 11.9878 11.3663 11.9624 11.3054C11.9371 11.2445 11.8999 11.1893 11.8531 11.1428L9.70485 8.99957Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7443_12881"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvRejected);
export default __webpack_public_path__ + "static/media/cv-rejected.8963a64bad198eaf7c5abe2d112de585.svg";
export { ForwardRef as ReactComponent };